import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { ClinicProvider } from './context/ClinicContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './routes/ProtectedRoute';
import AppLayout from './layouts/AppLayout';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Queue from './pages/Queue';
import NewPatient from './pages/NewPatient';
import Patients from './pages/Patients';
import PatientProfile from './pages/PatientProfile';
import Consultation from './pages/Consultation';
import PrintPrescription from './pages/PrintPrescription';
import Masters from './pages/Masters';
import Reports from './pages/Reports';
import ClinicSettings from './pages/ClinicSettings';
import NotFound from './pages/NotFound';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SocketProvider>
          <ClinicProvider>
            <ToastProvider>
              <Routes>
              <Route path="/login" element={<Login />} />

              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/queue" element={<Queue />} />

                <Route
                  path="/patients/new"
                  element={
                    <ProtectedRoute roles={['reception']}>
                      <NewPatient />
                    </ProtectedRoute>
                  }
                />
                <Route path="/patients" element={<Patients />} />
                <Route path="/patients/:id" element={<PatientProfile />} />

                <Route
                  path="/consultation/:visitId"
                  element={
                    <ProtectedRoute roles={['doctor']}>
                      <Consultation />
                    </ProtectedRoute>
                  }
                />
                <Route path="/print/:visitId" element={<PrintPrescription />} />

                <Route
                  path="/masters"
                  element={
                    <ProtectedRoute roles={['doctor']}>
                      <Masters />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <ProtectedRoute roles={['doctor']}>
                      <Reports />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute roles={['doctor']}>
                      <ClinicSettings />
                    </ProtectedRoute>
                  }
                />

                <Route path="*" element={<NotFound />} />
              </Route>
              </Routes>
            </ToastProvider>
          </ClinicProvider>
        </SocketProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
